import { RECEIVE_POSTS_SIMU_VEHICLE_DETAILS } from '../actions/actionsApiSimulation';
import { CALCULATOR_INIT, RECEIVE_POSTS_OFFERS, RECEIVE_POSTS_CRITERIA, RECEIVE_POSTS_SVCLEVELS } from '../actions/actionsApiOffer'
import {
    CALCULATOR_SET_MODE, CALCULATOR_SET_PARAMETERS, CALCULATOR_SET_CRITERIA_DEPOSIT, CALCULATOR_SET_CRITERIA_DURATION,
    CALCULATOR_SET_CRITERIA_MILEAGE, CALCULATOR_SET_CRITERIA_SVCMAP, CALCULATOR_SET_CRITERIA_PRODUCT, CALCULATOR_SET_CRITERIA_CUSTOMER,
    CALCULATOR_SELECT_BENEFIT, CALCULATOR_SELECT_SERVICE_INFO
} from '../actions/actionsAppCalculator'
import HelperCriteriaCalculator from '../helpers/HelperCriteriaCalculator'

export const initialStateCalculator = { vehicle: null, calculatorMode: 'CLASSICAL' };

function vehicle(state, action) {
    if (action.type === CALCULATOR_INIT) {
        return { ...state, ...action.payload.vehicle };
    }
    return { ...state };
}

function responseOffers(state, action) {
    if (action.type === RECEIVE_POSTS_OFFERS) {
        return {
            ...state,
            offers: Object.values({ ...action.payload.offers }),
            hasOffers: { ...action.payload.hasOffers },
            selectedProductId: { ...action.payload.parameters }
        };
    }
    return { ...state };
}

function responseCriteria(state, action) {
    if (action.type === RECEIVE_POSTS_CRITERIA) {
        return {
            ...action.payload.responseCriteria
        };
    }
    return { ...state };
}

function responseServiceLevels(state, action) {
    if (action.type === RECEIVE_POSTS_SVCLEVELS) {
        return {
            ...action.payload.responseServiceLevels
        };
    }
    return { ...state };
}

function parameters(state, action, recievedParams) {
    switch (action.type) {
        case CALCULATOR_SET_PARAMETERS:
        case RECEIVE_POSTS_CRITERIA:
            return recievedParams.parameters;
        case CALCULATOR_SET_CRITERIA_DEPOSIT:
            return { ...state, deposit: action.payload.deposit };
        case CALCULATOR_SET_CRITERIA_DURATION:
            return { ...state, duration: action.payload.duration, services: recievedParams.services };
        case CALCULATOR_SET_CRITERIA_MILEAGE:
            return { ...state, annualMileage: action.payload.mileage, services: recievedParams.services };
        case CALCULATOR_SET_CRITERIA_SVCMAP:
            return { ...state, services: HelperCriteriaCalculator.getServiceParameters(action.payload.svcMap) };
        case RECEIVE_POSTS_OFFERS:
            if (action.payload.parameters != null) {
                return { ...state, productKey: action.payload.parameters.productKey };
            }
            return state;
        case CALCULATOR_SET_CRITERIA_PRODUCT:
            return { productKey: action.payload.productKey };
        default:
            return state
    }
}

function customer(state, action, contextCustomerState) {
    if (action.type === CALCULATOR_SET_CRITERIA_CUSTOMER) {
        return { ...state, ...action.payload.customer, clientType: contextCustomerState.clientType };
    }
    return { ...state, clientType: contextCustomerState.clientType };
}

function calculatorMode(state, action) {
    if (action.type === CALCULATOR_SET_MODE) {
        return action.payload.calculatorMode;
    }
    return state
}

function benefit(state, action) {
    switch (action.type) {
        case CALCULATOR_SELECT_BENEFIT:
            return action.payload.benefit;
        case CALCULATOR_SET_CRITERIA_PRODUCT:
            return {};
        default:
            return state
    }
}
function serviceInformation(state, action) {
    switch (action.type) {
        case CALCULATOR_SELECT_SERVICE_INFO:
            return action.payload.service;
        case CALCULATOR_SET_CRITERIA_PRODUCT:
            return {};
        default:
            return state
    }
}

function contextCriteria(state, action, recievedParams) {
    switch (action.type) {
        case CALCULATOR_SET_CRITERIA_DURATION:
            return HelperCriteriaCalculator.getCriteriaLimit(recievedParams.svcMap, action.payload.duration, recievedParams.parameters.annualMileage);
        case CALCULATOR_SET_CRITERIA_MILEAGE:
            return HelperCriteriaCalculator.getCriteriaLimit(recievedParams.svcMap, recievedParams.parameters.duration, action.payload.mileage);
        case CALCULATOR_SET_CRITERIA_SVCMAP:
            return HelperCriteriaCalculator.getCriteriaLimit(action.payload.svcMap, recievedParams.parameters.duration, recievedParams.parameters.annualMileage);
        case RECEIVE_POSTS_CRITERIA:
            return HelperCriteriaCalculator.getCriteriaLimit(recievedParams.svcMap, recievedParams.parameters.duration, recievedParams.parameters.annualMileage);
        default:
            return state
    }
}

function svcMap(state, action, recievedParams) {
    switch (action.type) {
        case RECEIVE_POSTS_CRITERIA:
        case CALCULATOR_SET_CRITERIA_DURATION:
        case CALCULATOR_SET_CRITERIA_MILEAGE:
            return { ...recievedParams.svcMap };
        default:
            return state;
    }
}

function buildParameters(state, action) {
    let newParameters = {};
    let dataSvcMap = {};
    switch (action.type) {
        case RECEIVE_POSTS_CRITERIA:
            const responseCriteria = action.payload.responseCriteria;
            newParameters = action.payload.parameters;
            dataSvcMap = HelperCriteriaCalculator.getServiceMap(responseCriteria.packages, responseCriteria.services, newParameters);
            break;
        case CALCULATOR_SET_CRITERIA_DURATION:
            dataSvcMap = state.svcMap;
            for (const svcKey in state.svcMap) {
                dataSvcMap[svcKey]['selectable'] = HelperCriteriaCalculator.isSelectableCriteria(
                    state.svcMap[svcKey], action.payload.duration, state.parameters.annualMileage, state.parameters.globalMileage);
            }
            newParameters = state.parameters;
            newParameters.services = HelperCriteriaCalculator.getServiceParameters(dataSvcMap);
            break;
        case CALCULATOR_SET_CRITERIA_MILEAGE:
            dataSvcMap = state.svcMap;
            for (const svcKey1 in state.svcMap) {
                dataSvcMap[svcKey1]['selectable'] = HelperCriteriaCalculator.isSelectableCriteria(
                    state.svcMap[svcKey1], state.parameters.duration, action.payload.mileage, null);
            }
            newParameters = state.parameters;
            newParameters.services = HelperCriteriaCalculator.getServiceParameters(dataSvcMap);
            break;
        default:
            newParameters = state.parameters;
            dataSvcMap = state.svcMap;
            break;
    }
    const svcLevelFiltered = HelperCriteriaCalculator.getServiceLevelsFiltered(dataSvcMap, state.responseServiceLevels);
    return { newParameters: newParameters, dataSvcMap: dataSvcMap, svcLevelFiltered: svcLevelFiltered };
}

function responseVehicleSimulationDetails(state, action) {
    if (action.type === RECEIVE_POSTS_SIMU_VEHICLE_DETAILS
        && action.payload.isCalculator) {
        return { ...state, vehicleDetails: action.payload.responseSimulationVehicleDetails };
    }
    return state;
}

export function calculator(state, action, contextState) {
    const newParametersAndSvcMap = buildParameters(state, action);
    const responseCriteriaState = responseCriteria(state.responseCriteria, action);
    const durationsFilteredState = HelperCriteriaCalculator.getBoundedDurations(responseCriteriaState.durations,
        newParametersAndSvcMap.dataSvcMap, newParametersAndSvcMap.newParameters && newParametersAndSvcMap.newParameters.annualMileage);
    const mileagesFiltered = HelperCriteriaCalculator.getBoundedMileages(responseCriteriaState.mileages,
        newParametersAndSvcMap.dataSvcMap, newParametersAndSvcMap.newParameters && newParametersAndSvcMap.newParameters.duration);
    return {
        ...state,
        calculatorMode: calculatorMode(state.calculatorMode, action),
        vehicle: vehicle(state.vehicle, action),
        responseOffers: responseOffers(state.responseOffers, action),
        responseServiceLevels: responseServiceLevels(state.responseServiceLevels, action),
        responseCriteria: responseCriteriaState,
        responseVehicleSimulationDetails: responseVehicleSimulationDetails(state.responseVehicleSimulationDetails, action),
        parameters: parameters(state.parameters, action, { parameters: newParametersAndSvcMap.newParameters }),
        customer: customer(state.customer, action, contextState.customer),
        svcMap: svcMap(state.svcMap, action, { svcMap: newParametersAndSvcMap.dataSvcMap }),
        svcLevelFiltered: { ...newParametersAndSvcMap.svcLevelFiltered },
        benefit: benefit(state.benefit, action),
        serviceInformation: serviceInformation(state.serviceInformation, action),
        contextCriteria: {
            ...contextCriteria(state.contextCriteria, action,
                {
                    svcMap: newParametersAndSvcMap.dataSvcMap,
                    parameters: newParametersAndSvcMap.newParameters
                }),
            durationsFiltered: durationsFilteredState,
            mileagesFiltered: mileagesFiltered
        }
    };
}
